;(function () {
  'use strict'
  angular.module('obex').factory('authService', [
    '$http',
    '$q',
    '$window',
    'obexConstant',
    '$state',
    function ($http, $q, $window, obexConstant, $state) {
      const storage = $window.localStorage
      let cacheToken = {}
      let cachePermission = ''
      let cacheLoginMember = {}
      return {
        clear() {
          cacheToken.access_token = undefined
          cacheToken.refresh_token = undefined
          cacheToken.expires_in = undefined
          storage.clear()
        },

        setToken(token) {
          cacheToken.access_token = token.access_token
          storage.setItem('access_token', cacheToken.access_token)
          cacheToken.refresh_token = token.refresh_token
          storage.setItem('refresh_token', cacheToken.refresh_token)
          cacheToken.expires_in = token.expires_in
          storage.setItem('expires_in', cacheToken.expires_in)
        },

        setPermission(permission) {
          cachePermission = permission
          storage.setItem('permission', cachePermission)
        },

        setLoginMember(loginMember) {
          cacheLoginMember = loginMember
          storage.setItem('loginMember', JSON.stringify(loginMember))
        },

        getAuthorizationHeader() {
          if (cacheToken.access_token && cacheToken.expires_in > moment(new Date().getTime()).unix())
          {
            return $q.when({
              Authorization: 'Bearer ' + cacheToken.access_token,
            })
          } else {
            cacheToken.access_token = storage.getItem('access_token')
            cacheToken.refresh_token = storage.getItem('refresh_token')
            cacheToken.expires_in = Number(storage.getItem('expires_in'))
            if (
              cacheToken.access_token &&
              cacheToken.expires_in > moment(new Date().getTime()).unix()
            ) {
              return $q.when({
                Authorization: 'Bearer ' + cacheToken.access_token,
              })
            } else {
              return $http
                .post('/refreshToken', { token: cacheToken.refresh_token })
                .then(
                  (response) => {
                    const token = response.data
                    cacheToken.access_token = token.access_token
                    storage.setItem('access_token', cacheToken.access_token)
                    cacheToken.refresh_token = token.refresh_token
                    storage.setItem('refresh_token', cacheToken.refresh_token)
                    cacheToken.expires_in = token.expires_in
                    storage.setItem('expires_in', cacheToken.expires_in)
                    return {
                      Authorization: 'Bearer ' + cacheToken.access_token,
                    }
                  },

                  (err) => {
                    $state.go('login')
                  },
                )
            }
          }
        },

        isAuthenticated() {
          if (cacheToken.access_token) {
            return true
          } else {
            if (storage.getItem('access_token')) {
              //reload cache with localStorage
              cacheToken.access_token = storage.getItem('access_token')
              cacheToken.refresh_token = storage.getItem('refresh_token')
              cacheToken.expires_in = storage.getItem('expires_in')
              return true
            } else {
              return false
            }
          }
        },

        userHasPermission(permissions) {
          let permission = cachePermission
          if (!permission) {
            permission = storage.getItem('permission')
          }

          return !!_.find(permissions, (p) => p === permission)
        },

        getLoginMember() {
          let loginMember = cacheLoginMember
          if (loginMember.Email === undefined) {
            loginMember = JSON.parse(storage.getItem('loginMember'))
          }

          return loginMember
        },

        getTokenFromCredential(email, password) {
          return $http.post('/login', {email,password})
        },

        signup(email, password, firstName, lastName) {
          const postData = {
            Email: email,
            Password: password,
            FirstName: firstName,
            LastName: lastName,
          }
          return $http.post(obexConstant.urlActivation, postData)
        },

        completeActivation(password, guid) {
          const postData = {
            Password: password,
            Guid: guid,
          }
          return $http.post(obexConstant.urlCompleteActivation, postData)
        },

        forgotPassword(email, newPassword) {
          const postData = {
            Email: email,
            Password: newPassword,
          }
          return $http.post(
            `${obexConstant.urlResetPassword}/${email}`,
            postData,
          )
        },
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./client/js/services/auth.service.js